<template>
    <v-tab-item :value="JOIN.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <div>
                    <v-row>
                        <v-col cols="12" lg="3">
                            <h2 class="tit">회원가입</h2>
                        </v-col>
                        <v-col cols="12" lg="9">
                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">회원 가입</h4>
                                </div>
                                <p class="page-text">
                                    캐터옥션에 작품을 위탁하시거나, 경매에 응찰하기 위해서 반드시 회원가입을 하셔야 합니다. 회원가입은 별도의 연회비 없이, 캐터옥션 홈페이지 및 프리뷰 전시장에서 가입 가능합니다. 캐터옥션 회원은 경매 안내 이메일, 문자 등을 받아 보실 수 있습니다.
                                </p>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">홈페이지 회원가입</h4>
                                </div>
                                <p class="page-text">
                                    홈페이지 우측 상단에 있는 &lt;회원가입&gt;에서 작성해 주시기 바랍니다. 회원가입 후 로그인이 필요합니다. 우측 상단의 &lt;로그인&gt;을 통하여, 본인인증을 완료하면 누구나 참여가 가능합니다
                                </p>
                                <p class="page-text primary--text mt-16 mt-md-26">
                                    ※ 회원가입 중 어려운 점이 발생할 경우 언제든 문의 주시기 바랍니다. 02-395-6987
                                </p>
                            </div>

                            <v-divider class="grey-cb my-30 my-md-36"></v-divider>

                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Membership Registration</h4>
                                </div>
                                <p class="page-text">
                                    Membership Registration is required in order to bid or sell at KATA Auction. Membership registration is available on the KATA Auction website and preview exhibition hall without an annual fee. Members can receive auction news by email and SMS.
                                </p>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Online Registration</h4>
                                </div>
                                <p class="page-text">
                                    Please fill out the &lt;Member Registration&gt; section at the top right  on the website. After registering, you need to log in. Anyone can participate after completing identity verification through &lt;Login&gt; at the top right  on the website.
                                </p>
                                <p class="page-text primary--text mt-16 mt-md-26">
                                    ※ If you encounter any difficulties during membership registration, please contact us. 02-395-6987
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { HOW_TO_BID_TABS } from "@/assets/variables";
const { JOIN } = HOW_TO_BID_TABS;
export default {
    data() {
        return {
            JOIN,
        };
    },
};
</script>

<style></style>
